import { useEffect, useState } from "react";
import Finished from "./components/Finished";
import Loading from "./components/Loading";
import ErrorRequest from "./components/ErrorRequest";
import { getUuid, getModel, ccsRadius, getInterest } from "./utils";
import getLocation from "../services/location";
import axios from "axios";
import css from "./styles.module.css";
import Concessionaria from "./components/Concessionaria";

const INTERESTS = {
  "":"",
  "Agendar test-drive": "HAB",
  "Preços e condições": "HAB",
  "Semi-novo": "HAB",
  "Agendamento de Serviços": "CS",
  Peças: "CS",
  "Outras Solicitações": "CS",
};

function App() {
  const [loading, setLoading] = useState(false);
  const [finished, setFinished] = useState(false);
  const [errorRequest, setErrorRequest] = useState(false);
  const [formType, setFormType] = useState("CPF");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [CPF, setCPF] = useState("");
  const [CNPJ, setCNPJ] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [ccs, setCcs] = useState(null);

  const [type, setType] = useState("HAB");
  const [origin] = useState("Honda Social");
  const [subOrigin] = useState("Messenger");
  const [ccsCode, setCcsCode] = useState("");
  const [optInContact, setOptInContact] = useState(false);

  const [product, setProduct] = useState([]);
  const [interest, setInterest] = useState("");
  const formWarning = "Preencha o formulário";
  const [formError, setFormError] = useState(formWarning);
  const [location, setLocation] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const [uuid, setUuid] = useState("");

  useEffect(() => {
    setUuid(getUuid() || "");
    setProduct(getModel() || []);
    setInterest(getInterest() || "");
    getLocation(setLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  useEffect(() => {
    console.log(interest)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interest]);

  useEffect(() => {
    setCcs(ccsRadius(location));
  }, [location]);

  useEffect(() => {
    if (ccs && ccs.length) {
      setCcsCode(ccs[0].code);
      setSelectedId(ccs[0].code);
    }
  }, [ccs]);

  useEffect(() => {
    setFormError(() => formError);
    console.log("ERROR ALTERADO: ", formError);
  }, [formError]);

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeLastName = (event) => {
    setLastName(event.target.value);
  };

  const handleChangeCPF = (event) => {
    setCPF(event.target.value);
  };

  const handleChangeCNPJ = (event) => {
    setCNPJ(event.target.value);
  };

  const handleChangePhone = (event) => {
    setPhone(event.target.value);
  };

  const validEmailRegex = RegExp(
    /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i
  );

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const validations = () => {
    if (name.length === 0) {
      setFormError("Nome não pode ser vazio");
    } else if (interest.length === 0) {
      setFormError("Interesse não pode ficar vazio");
    } else if (/\d/.test(name)) {
      setFormError("Nome não pode conter números");
    } else if (lastName.length === 0) {
      setFormError("Sobrenome não pode ser vazio");
    } else if (/\d/.test(lastName)) {
      setFormError("Sobrenome não pode conter números");
    } else if (CPF.length === 0 && formType === "CPF") {
      setFormError("CPF não pode ser vazio");
    } else if (!/^[0-9]*$/.test(CPF) && formType === "CPF") {
      setFormError("CPF deve conter apenas números");
    } else if (CPF.length < 11 && formType === "CPF") {
      setFormError("CPF deve conter 11 números");
    } else if (CNPJ.length === 0 && formType === "CNPJ") {
      setFormError("CNPJ não pode ser vazio");
    } else if (!/^[0-9]*$/.test(CNPJ) && formType === "CNPJ") {
      setFormError("CNPJ deve conter apenas números");
    } else if (CNPJ.length < 14 && formType === "CNPJ") {
      setFormError("CNPJ deve conter 14 números");
    } else if (phone.length === 0) {
      setFormError("Telefone não pode ser vazio");
    } else if (!/^[0-9]*$/.test(phone)) {
      setFormError("Telefone deve conter apenas números");
    } else if (phone.length < 10) {
      setFormError("Telefone inválido (Deve Conter DDD)");
    } else if (email.length === 0) {
      setFormError("E-mail não pode ser vazio");
    } else if (!validEmailRegex.test(email)) {
      setFormError("Formato de email inválido");
    } else if (!optInContact) {
      setFormError("Você deve aceitar os termos.");
    } else {
      setFormError("");
      return true;
    }
  };

  function capitalizeWord(word) {
    if (typeof word !== "string") {
      return "";
    }
    return word.charAt(0).toUpperCase() + word.substr(1);
  }

  const handleSend = async (event) => {
    event.preventDefault();
    const isValid = validations();
    const modelVersion = `${capitalizeWord(product.model)} ${product.version}`;

    const data = {
      first_name: name,
      last_name: lastName,
      cpf__c: CPF,
      mobile: phone,
      email: email,
      type__c: type,
      lead_source: origin,
      sub_source_media__c: subOrigin,
      dealer_code_interest__c: ccsCode,
      opt_in_email__c: optInContact ? 1 : 0,
      opt_in_phone__c: optInContact ? 1 : 0,
      model_interest__c: `${modelVersion} - ${interest}`,
      oid: "00D0v0000000SZk",
      debug: 1,
      debugEmail: "geovane.silva@elife.com.br",
    };

    if (formType === "CPF") {
      data.cpf__c = CPF;
    } else {
      data.cnpj__c = CNPJ;
    }

    if (isValid) {
      setLoading(true);

      const response = await axios('/api/csrf-token');
      const { token } = await response.data;
      
      const res = await axios.post("/webtolead", {
        lead: data,
        uuid,
      }, {
        headers: {
          'x-csrf-token': token
        }
      });
      console.log(res);
      if (res.status === 200) {
        setLoading(false);
        setFinished(true);
      } else {
        setLoading(false);
        setErrorRequest(true);
      }
    } else {
      console.log(formError);
    }
  };

  if (loading) return <Loading />;

  if (finished) return <Finished />;

  if (errorRequest) return <ErrorRequest />;

  const modelo = capitalizeWord(product.model);
  const versao = product.version || '---';

  const getType = (interest) => {
    return INTERESTS[interest];
  };

  return (
    <div className={css.container}>
      <div className={css.pageHeader}>
        <img
          src="https://storage.googleapis.com/teamelifebots/Honda/Honda%20Automoveis_3d_Horizontal_COLOR.png"
          alt="Logo da Honda"
        ></img>
        <hr />
        <div>
          <span className={css.titulo}>Escolha o Honda ideal para você</span>.
        </div>
      </div>

      <div className={css.wrapper}>
        <div>
          <section>
            <form>
              <label className={css.etiqueta}>Modelo</label>
              <div>
                <input placeholder={modelo} />
              </div>
              <label className={css.etiqueta}>Versão</label>
              <div>
                <input placeholder={versao} />
              </div>
              <label className={css.etiqueta}>Interesse</label>
              <div>
                <select
                  value={interest}
                  onChange={(event) => {
                    const tempInterest = event.target.value;
                    const tempType = getType(tempInterest);
                    console.log(
                      "Alterando event",
                      event,
                      JSON.stringify({ tempInterest, tempType })
                    );
                    setInterest(tempInterest);
                    setType(tempType);
                  }}
                >
                  {Object.keys(INTERESTS).map((valueInterest) => (
                    <option value={valueInterest}>{valueInterest}</option>
                  ))}
                </select>
              </div>
            </form>
          </section>

          <section>
            <form>
              <div className={css.subtitulo}>
                <span>Dados Pessoais</span>
              </div>

              <div>
                <select
                  value={formType}
                  onChange={(event) => setFormType(event.target.value)}
                  className={css.inputSelect}
                >
                  <option value="CPF">Pessoa Física</option>
                  <option value="CNPJ">Pessoa Jurídica</option>
                </select>
              </div>
              <label className={css.etiqueta}>Nome</label>
              <div>
                <input
                  placeholder="Digite seu nome"
                  onChange={handleChangeName}
                  maxLength={40}
                  className={css.entrada}
                />
              </div>
              <label className={css.etiqueta}>Sobrenome</label>
              <div>
                <input
                  placeholder="Digite o seu sobrenome"
                  onChange={handleChangeLastName}
                  maxLength={80}
                  className={css.entrada}
                />
              </div>
              <label className={css.etiqueta} hidden={formType === "CNPJ"}>
                CPF - Apenas números
              </label>
              <div>
                <input
                  placeholder="Insira seu CPF"
                  hidden={formType === "CNPJ"}
                  onChange={handleChangeCPF}
                  maxLength={11}
                  className={css.entrada}
                />
              </div>
              <label className={css.etiqueta} hidden={formType === "CPF"}>
                CNPJ - Apenas números
              </label>
              <div>
                <input
                  placeholder="Insira seu CNPJ"
                  hidden={formType === "CPF"}
                  onChange={handleChangeCNPJ}
                  maxLength={14}
                  className={css.entrada}
                />
              </div>
              <label className={css.etiqueta}>Celular com DDD</label>
              <div>
                <input
                  placeholder="Insira o seu celular com DDD"
                  onChange={handleChangePhone}
                  maxLength={11}
                  className={css.entrada}
                />
              </div>
              <label className={css.etiqueta}>E-mail</label>
              <div>
                <input
                  placeholder="Insira o seu e-mail"
                  onChange={handleChangeEmail}
                  maxLength={50}
                  className={css.entrada}
                />
              </div>

              <div>
                <div className={css.checkbox}>
                  <input
                    name="optin"
                    type="checkbox"
                    checked={optInContact}
                    onChange={() => setOptInContact(!optInContact)}
                  />
                  <label className={css.entrada}>
                    Autorizo a Honda a coletar, armazenar e tratar meus dados
                    pessoais, compartilhá-los com sua rede de concessionárias,
                    parceiros comerciais e fornecedores, bem como usá-los para
                    comunicações por aplicativos de mensagens instantâneas (ex.:
                    WhatsApp), SMS, ligações e e-mails nos termos previstos na{" "}
                    <a
                      href="https://www.honda.com.br/politica-de-privacidade"
                      target="_blank"
                    >
                      Política de Privacidade
                    </a>
                    .
                  </label>
                </div>
              </div>
              <br />
              {formError && formError !== formWarning && (
                <span className={css.error}>
                  {formError}
                  <br />
                </span>
              )}

              <div>
                <div className={css.subtitulo}>
                  <span>Selecione a concessionária</span>
                </div>
                <div className={css.wrapper}>
                  {ccs &&
                    ccs.map((concessionaria) => (
                      <div
                        key={concessionaria.code}
                        id={concessionaria.code}
                        onClick={() => {
                          setCcsCode(() => concessionaria.code);
                          setSelectedId(() => concessionaria.code);
                        }}
                        className={
                          selectedId === concessionaria.code
                            ? css.selectedConcessionariaWrapper
                            : css.concessionariaWrapper
                        }
                      >
                        <Concessionaria concessionariaData={concessionaria} />
                      </div>
                    ))}
                </div>
              </div>

              <button
                type="button"
                onClick={handleSend}
                className={css.sendButton}
              >
                Solicitar Contato
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default App;
